export class IFormFields{
    _id: string;
    form: string;
    field: string;
    mandatory: boolean;
    isActive: boolean;
    isDelete: boolean;
    company: string;
    branch: string;
    createdBy: string;
    modifiedBy: string;
    createdDate: Date;
    modifiedDate: Date;
}